<template>
	<div>
    <addorginstaff style="z-index: 10000" v-if="maskshow && masktype== 'adddepart'"
                 :default="selectList"
                 :parentListDefault="selectIds"
                 :type="1"
                 @sub="sub"></addorginstaff>
		<SsgMessagebox :titles='title'  height="auto" width="500px" >
			<div class="form">

			<slot></slot>
				
			</div>
		</SsgMessagebox>
	</div>
</template>
<script>
	export default {
		props: {
		    title:{
                type: String
			},
			visible: {
				type: Boolean,
				default: false
			},
			chooseId: {
				type: String
			},
			orgModel: {
				type: Object
			},
			stringify:{
				type: String
			}
		},
		data() {
			return {
        selectList:[],
        masktype:'',
        maskshow:false,
        pep: false,
        changeBtn:0,
        selectIds: [],
        chargeNameList: [],
				treeData: [],
				props: {
					label: 'label',
					value: 'id',
					children: 'children',
				},
				organization: {
					orgName: "",
					type: 0,
					parentId: "",
					userId: "",
          chargeName:'',

				},
				rules: {
					orgName: [{
						required: true,
						message: '请输入组织名称',
						trigger: 'blur'
					}, {
						min: 2,
						max: 20,
						message: "长度在 3 到 20 个字符"
					}],
					parentId: [{
						required: true,
						message: '请输入上级组织',
						trigger: 'change'
					}]
				},
			}
		},
		created() {
			this.loadTree();
		},
		watch: {
			chooseId(val) {
				if (val) {
					this.organization.parentId = val
				}
			},
			orgModel(val) {
				if (val.id) {
					this.organization.orgName = val.label;
					this.organization.id = val.id;
					this.chargeNameList = [];
                    this.selectIds = JSON.parse(JSON.stringify(val.chargeName.split(',')))
                    this.selectList = JSON.parse(JSON.stringify(val.userId.split(',')))
					this.chargeNameList.push({
						chargeName: val.chargeName,
						userid: val.userId
					});
					this.organization.userId = val.userId;
					this.organization.type = val.type;
					this.organization.parentName = val.parent.label;
					this.organization.chargeName = val.chargeName;
				} else {
          this.selectIds=[]
          this.selectList = []
					this.organization = {}
					this.organization.parentId = this.chooseId;
					// this.organization.type = 0;
				}
			}
		},
		methods: {
      sub(ids, id) {
        console.log(ids, id)
        this.maskshow = false
        this.masktype = 'adddeparts'
        // this.adddepart = true

          this.selectIds = [...id]
          this.selectList = [...ids]
        this.organization.userId =  this.selectList.toString();
        this.organization.chargeName =  this.selectIds.toString();

        // this.orgLists = [...orgId]

      },
      deletpepoe(index) {
        this.selectIds.splice(index, 1)
        this.selectList.splice(index, 1)
        // this.orgLists.splice(index, 1)
        this.organization.userId =  this.selectList.toString();
        this.organization.chargeName =  this.selectIds.toString();




      },
      //选择考勤组人员弹窗
      returactor() {
        this.changeBtn = 2
        this.pep = false
        this.maskshow = true
        this.masktype = 'adddepart'
      },
			remoteMethod(query) {
				this.$axios.get('/employee/findOrgChargeNameInEmployee?name=' + query)
					.then(res => {
						if (res.data.status == 1) {
							this.chargeNameList = res.data.data;
						}
					})
			},
			loadTree() {
				this.$axios.get('org/tree').
				then(res => {
					this.treeData = res.data.data;
				}).catch(err => {
					console.error(err)
				})
			},
			addOrg() {
				this.$refs.organization.validate((valid) => {
					if (valid) {
						this.$axios.post('/org/addOrg', this.organization)
							.then(res => {
								if (res.data.status == 1) {
									this.$message.success(res.data.message)
									this.addRecord();
									this.$emit('close')
									this.$emit('callback', res.data.data)
									this.loadTree()
								} else {
									this.$message.error(res.data.message)
								}
							})
					}
				})
			},
			closewin() {
				this.$refs['organization'].resetFields();
				this.$emit('close')
			},
			checklabel(v){
				this.organization.parentName = v;
			},
			onorganization(val){
				this.chargeNameList.forEach(v=>{
					if(v.userid == val){
						this.organization.chargeName = v.chargeName;
					}
				})
			},
			addRecord() {
				var obj = {};
				obj.orgName = this.organization.orgName;
				obj.type = this.organization.type;
				obj.chargeName = this.organization.chargeName;
				obj.parentName = this.organization.parentName;
				var param = "oldJson=" + this.stringify + "&newJson=" + JSON.stringify(obj) + "&category=9&type=2&recordId=" + this.organization.id;
				this.$axios.post('operationLog/addRecord', param)
					.then(res => {
						console.log(res);
					}).catch(e => console.info(e));
			}
		}
	}
</script>
<style scoped lang="less">
	.el-select {
		width: 100%;
	}

	.form {
		width: 100%;
		margin: 30px 0;
	}
</style>
